import script from "./tablist.vue?vue&type=script&lang=ts&setup=true"
export * from "./tablist.vue?vue&type=script&lang=ts&setup=true"

import "./tablist.vue?vue&type=style&index=0&id=9f6d3b54&lang=less&scoped=true"

import exportComponent from "E:\\twl\\workspace\\auxiliary-ts-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f6d3b54"]])

export default __exports__